exports.list = {
    path: '/laporan_pengeluaran_equipment',
    name: 'laporan_pengeluaran_equipment_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_pengeluaran_equipment/List.vue"),
}